import React, { useEffect, useState } from 'react';
import Step from './Step';
import { stepperConfig as stepperConfigStatic } from '../configs/headerConfigs/config';

function StepperHeader({ numberOfSteps,
  stepperConfig = stepperConfigStatic,
   currentStep, ...props }) {
  
  const [classNameForHeaderContainer, setClassNameForHeaderContainer] = useState('');

  useEffect(() => {
    setClassNameForHeaderContainer(numberOfSteps === 3 ? 'stepper-header-with-3-container' : numberOfSteps === 4 ? 'stepper-header-with-4-container' : 'stepper-header-with-5-container'); 
  }, [numberOfSteps]);

  return (
    <div className={`stepper-header-container ${classNameForHeaderContainer}`}>
      {stepperConfig &&
        stepperConfig.map((step, index) => (
          <div className={`stepper-header-step-grid-column-${index+1}`}>
            <Step
              currentStep={currentStep}
              key={index}
              step={step}
              className="stepper-header-step"
              {...props}
            />
          </div>
        ))}
    </div>
  );
}

export default StepperHeader;